import React from 'react';
import { createRoot } from 'react-dom/client';  // Güncellenmiş import
import './index.css';  // Stil dosyasını bağlayın, varsa
import App from './App.jsx';
import './i18n';

// Performans izleme (isteğe bağlı)
// import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);  // createRoot çağrısını güncelleyin
root.render(<App />);

// Performans izleme fonksiyonunu çağırabilirsiniz (isteğe bağlı)
// reportWebVitals();